import {
  SET_SELECTED_PET,
  SET_PET_LIST,
  SET_SPECIES_LIST,
  SET_RACE_LIST,
  RESET_PETS_STATE,
  SELECTED_PET_KEY,
  PET_LIST_KEY,
  SPECIES_LIST_KEY,
  RACE_LIST_KEY,
} from '../../types/pets.types'
import initialState from './state'

export default {
  [SET_SELECTED_PET]: (state, payload) => {
    state[SELECTED_PET_KEY] = payload
  },
  [SET_PET_LIST]: (state, payload) => {
    state[PET_LIST_KEY] = payload
  },
  [SET_SPECIES_LIST]: (state, payload) => {
    state[SPECIES_LIST_KEY] = payload
  },
  [SET_RACE_LIST]: (state, payload) => {
    state[RACE_LIST_KEY] = payload
  },
  [RESET_PETS_STATE]: (state) => {
    Object.assign(state, initialState())
  },
}
